import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
// @mui
import { Bolt, Check, Login } from "@mui/icons-material";
import { Button, CircularProgress, MenuItem, Stack, TextField } from "@mui/material";
// components
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
//
import { PATHS } from "src/routes/paths";
import useAppContext from "src/hooks/useAppContext";

function FastForm({ user }) {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    name: '',
    phone: '',
    street: '',
    district: '',
    ref: ''
  });
  const [errors, setErrors] = useState({});

  const { enqueueSnackbar } = useSnackbar();
  const { setLocalUser, deliveryStatus, updateUserAttributes } = useAppContext();

  useEffect(() => {
    if (user) {
      delete user.createdAt;
      setValues({
        ...user,
        phone: user.phone?.replace('+55', '') || ''
      });
    }
  }, [user]);

  const setValue = (key, value) => setValues(prev => ({ ...prev, [key]: value }))
  const setError = (key, value) => setErrors(prev => ({ ...prev, [key]: value }))

  const handleChangeField = (key, value) => {
    setValue(key, value);
    if (value) {
      setError(key, null);
    } else setError(key, 'Campo obrigatório');
  }

  const confirm = async () => {
    const errors = {};
    Object.entries(values).forEach(([k, v]) => {
      if (!v) {
        errors[k] = 'Campo obrigatório';
      }
    })

    setErrors(errors);

    if (Object.keys(errors).length) {
      return;
    }

    if (user?.email) {
      try {
        setLoading(true);
        await updateUserAttributes({
          name: values.name,
          phone_number: `+55${values.phone}`,
          'custom:street': values.street,
          'custom:district': values.district,
          address: `${values.street}, ${values.district}`,
          'custom:ref': values.ref
        });
        setLoading(false);
      }
      catch (err) {
        console.error(err);
        enqueueSnackbar('Erro ao atualizar os dados!', { variant: 'error' });
        setLoading(false);
        return;
      }
      enqueueSnackbar('Dados salvos com sucesso!', { variant: 'success' });
    }
    else {
      setLocalUser(values);
    }

    window.location.href = PATHS.cart;
  }

  return (
    <Stack direction={'column'} spacing={2} sx={{ my: 2 }}>
      <TextField
        label="Nome completo"
        value={values.name}
        onChange={(e) => handleChangeField('name', e.target.value)}
        error={Boolean(errors.name)}
        helperText={errors.name}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      />

      <TextField
        label="Telefone"
        value={values.phone}
        onChange={(e) => {
          const n = Number(e.target.value.replace(/\D/g, ''));
          e.target.value = n;
          handleChangeField('phone', e.target.value);
        }}
        error={Boolean(errors.phone)}
        helperText={errors.phone}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      />

      <TextField
        label="Endereço"
        value={values.street}
        onChange={(e) => handleChangeField('street', e.target.value)}
        error={Boolean(errors.street)}
        helperText={errors.street}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      />

      <TextField
        select
        label="Bairro"
        value={values.district}
        onChange={(e) => handleChangeField('district', e.target.value)}
        error={Boolean(errors.district)}
        helperText={errors.district}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      >
        {deliveryStatus?.districts?.map(e =>
          <MenuItem key={e.name} value={e.name}>{e.name}</MenuItem>
        )}
      </TextField>

      <TextField
        label="Referência"
        value={values.ref}
        onChange={(e) => handleChangeField('ref', e.target.value)}
        error={Boolean(errors.ref)}
        helperText={errors.ref}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      />

      <Button
        variant="contained"
        onClick={confirm}
        startIcon={!loading && <Check />}
        disabled={loading}
        sx={{ width: { xs: '100%', sm: '50%' } }}
      >
        {loading ? <CircularProgress size={20} />
          :
          (user ? 'Salvar alterações' : 'Confirmar')
        }
      </Button>
    </Stack>
  )
}

export default function LoginIndex() {
  const [fastOrder, setFastOrder] = useState(false);

  const { user } = useAppContext();
  const { search } = useLocation();

  // const redirect = new URLSearchParams(search).get('redirect');

  useEffect(() => {
    if (user)
      setFastOrder(true);
  }, [user]);

  return (
    <>
      <div style={{ position: 'fixed', backgroundImage: 'url("bg.jpg")', height: '100vh', width: '100vw', filter: 'brightness(30%)' }} />
      <Page title='Indentifique-se' sx={{ zIndex: 2, position: 'relative' }}>
        <PageHeader
          title="Identifique-se"
        />

        {fastOrder ?
          <FastForm user={user} />
          :
          <Stack direction={'column'} spacing={2} alignItems={'center'} sx={{ my: 2 }}>
            <Button
              variant="contained"
              component={NavLink}
              to={`/auth${search}`}
              startIcon={<Login />}
              sx={{ width: { xs: '100%', sm: '40%' } }}
            >
              Fazer login/cadastro
            </Button>

            <Button
              variant="contained"
              startIcon={<Bolt />}
              onClick={() => setFastOrder(true)}
              sx={{ width: { xs: '100%', sm: '40%' } }}
            >
              Pedido simples (sem cadastro)
            </Button>
          </Stack>
        }
      </Page>
    </>
  )
}